import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'components/common/Link/Link'
import { Instructions } from '../components/Recovery/ForgotPages.styles'

const ForgotEmail = ({ name, instructions, contactAt: { path }, handleHide }) =>
  <div>
    <Instructions data-at-instructions>{ instructions }</Instructions>
    <Contact>
      <Link data-at-forgotusernamemodal-contactus to={ path } onClick={ handleHide }>Contact us</Link>
    </Contact>
  </div>

ForgotEmail.propTypes = {
  contactAt: PropTypes.shape({
    path: PropTypes.string
  }),
  handleHide: PropTypes.func,
  instructions: PropTypes.string,
  name: PropTypes.string
}

ForgotEmail.type = 'ForgotEmail'

export default ForgotEmail

const Contact = styled.div`
  margin-top: 38px;
`
